import {Grid, withStyles, TextField, InputAdornment, IconButton} from "@material-ui/core";
import {Field} from "formik";
import classNames from "classnames";
import * as PropTypes from "prop-types";
import style from "./styles";
import React from "react";
import Autocomplete, {createFilterOptions} from '@material-ui/lab/Autocomplete';
import {IconFechar} from "../icons/MateraIcons";
import is from "is_js";

const InputAutoCompleteBuilder = (props) => {
    const [open, setOpen] = React.useState(false);
    const {classes, fieldSchema: schema, form} = props;

    const optionsReducer = (fieldName) => (state, data) => {
        if(!data || !data.length){
            return [{[fieldName]: ''}]
        }
        return data;
    };

    const [options, setOptions] = React.useReducer(optionsReducer(schema.field), [{[schema.field]: ''}]);

    const {
        getOptions = () => {},
        getOptionLabel = option => (typeof option === 'object' && option !== {} && option?.[schema.field]) || '',
        onChange = schema.onChange ?? ((ev, value) => form.setValues(value ?? {})),
        getOptionSelected = (opt, val) => (opt[schema.field] === val[schema.field] || (options.length === 1 && opt[schema.field] === ''))

    } = schema;
    React.useLayoutEffect(() => {
        if(!schema.disabled){
            getOptions(setOptions);
            form.setValues(form.values)
        }
    }, []);
    return <Grid item {...schema.sizes}>
        <Field name={schema.field} {...props} required={schema.isRequired} initialTouched>
            {
                ({field, form}) => {
                    const [valueAC, setValueAC] = React.useState(getOptionLabel(field.value));
                    React.useLayoutEffect(() => {
                            setValueAC(getOptionLabel(form.values))
                        },
                        [form.values]
                    );
                    React.useLayoutEffect(() => {
                            if(!schema.disabled)
                                getOptions(setOptions)
                        },
                        [schema.disabled, form.values[schema.listen]]
                    );

                    const filterOptions = createFilterOptions({
                        stringify: option => {
                            if(schema.disabled)
                                return;
                            return getOptionLabel(option)
                        },
                    });
                    return <Autocomplete
                        open={open}
                        onOpen={() => {
                            setOpen(true);
                        }}
                        onClose={() => {
                            setOpen(false);
                        }}
                        autoComplete
                        autoHighlight
                        filterOptions={filterOptions}
                        getOptionLabel={getOptionLabel}
                        getOptionSelected={getOptionSelected}
                        options={options}
                        value={form.values}
                        defaultValue=""
                        inputValue={valueAC}
                        disabled={schema.disabled}
                        onChange={(ev, value) => {
                            setValueAC(getOptionLabel(value));
                            onChange(ev, value);
                        }}
                        onInputChange={(ev, value) => setValueAC(value)}

                        onBlur={() => setValueAC(getOptionLabel(form.values))}
                        renderInput={params => {
                            params.InputProps.className = '';
                            params.InputProps.required = schema.isRequired;
                            if(params.InputProps.endAdornment.props.children[0]){
                                let Arrow = params.InputProps.endAdornment.props.children[1];
                                params.InputProps.endAdornment =  <>
                                    {
                                        is.not.empty(valueAC) &&
                                        <InputAdornment position="end" className={'clear'}>
                                            <IconButton tabIndex="-1" size={"small"} onClick={schema.clear}>
                                                <IconFechar size={16}/>
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    {
                                        Arrow
                                    }
                                </>
                            }

                            return <TextField
                                {...params}
                                label={schema.label}
                                className={classNames(...params.InputProps.className, classes.margin)}/>
                        }}
                    />
                }
            }
        </Field>
    </Grid>;
};


InputAutoCompleteBuilder.propTypes = {
    classes: PropTypes.any,
    fieldSchema: PropTypes.any
};

export default withStyles(style)(InputAutoCompleteBuilder);
